import { render } from "./AdminExternalForms.vue?vue&type=template&id=65d1859a&scoped=true"
import script from "./AdminExternalForms.vue?vue&type=script&lang=js"
export * from "./AdminExternalForms.vue?vue&type=script&lang=js"

import "./AdminExternalForms.vue?vue&type=style&index=0&id=65d1859a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65d1859a"]])

export default __exports__